"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseAllVisibility = void 0;
/**
 * {@docCategory GroupedList}
 */
var CollapseAllVisibility;
(function (CollapseAllVisibility) {
    CollapseAllVisibility[CollapseAllVisibility["hidden"] = 0] = "hidden";
    CollapseAllVisibility[CollapseAllVisibility["visible"] = 1] = "visible";
})(CollapseAllVisibility || (exports.CollapseAllVisibility = CollapseAllVisibility = {}));
//# sourceMappingURL=GroupedList.types.js.map